module.exports = __webpack_public_path__ + "d7b4ad98965581888948994a3a329d80.svg";